import React, { FC } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import ctaTypes from '../../../../../enums/CTA.enums';
import CTA from '../../../CTA';
import RoutableNotEditableLink from '../../../routableNotEditableLink';
import { TSolutionCardProps } from '../../types/solutions.types';
import { targetLinkdsk } from '../../../../../utils/targetDskLink';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import breakpoints from '../../../../../constants/breakpoints.constants';
import IconOrImage from './iconOrImage';
import { appendRootToRichTextInternalLinks } from '../../../../../utils/appendRootToRichTextInternalLinks.utils';
import { appendRootToInternalLink } from '../../../../../utils/appendRootToInternalLink.utils';

const SolutionCard: FC<TSolutionCardProps> = (props: TSolutionCardProps) => {
  const {
    cardItem: { title, description, button1, icon },
  } = props;
  const link = {
    value: {
      text: button1?.label,
      href: appendRootToInternalLink(button1?.url),
      target: button1?.target,
    },
  };

  const cardDescription = appendRootToRichTextInternalLinks(description);
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  return (
    <RoutableNotEditableLink href={link?.value?.href} target={targetLinkdsk(link, isDesktop)} className="solutions-card__link">
      <div className="solutions-card__text-wrapper">
        <IconOrImage icon={icon} />
        <div className="solutions-card__link--content">
          {title && <h3 className="solutions-card__title">{title}</h3>}
          <RichText tag="div" field={{ value: cardDescription }} className="solutions-card__subtitle rich-text" editable={false} />
          {link.value.href && link.value.text && (
            <div className="solutions-card__cta">
              <CTA type={ctaTypes.secondaryBlack} field={link} />
            </div>
          )}
        </div>
      </div>
    </RoutableNotEditableLink>
  );
};

export default React.memo(SolutionCard);
